import type { ReactNode } from 'react'
import { Toaster } from '@/components/common/Toast/Toaster'
import { useFlash } from '@/hooks/useFlash'

type Props = {
  children: ReactNode
}

/**
 * 全ページに適用される永続レイアウト
 * - Flashメッセージのトースト表示
 * - その他のグローバルコンポーネント
 */
export default function PersistentLayout({ children }: Props) {
  useFlash()
  return (
    <>
      {children}
      <Toaster />
    </>
  )
}
